<body>
  <p>Der Login wird verarbeitet. Bitte warten...</p>

  <div id="errorDiv" style="color: red; display: none;">
    <p>Es sind Fehler aufgetreten! Bitte melde dich mit dieser Fehlerseite beim ASVZ Staff App <a href="mailto:info@asvz.ch">info&#64;asvz.ch</a>.</p>
    <p>Timestamp: <span id="timestamp"></span></p>
    <p id="errorMsg"></p>
  </div>
</body>
